import documentTypes from './types';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case documentTypes.GET_DOCUMENTS:
      return { ...state, ...{ fetching: true } };
    case documentTypes.DOCUMENTS_SUCCESS:
      return { ...state, ...{ dataList: action.payload, fetching: false } };

    case documentTypes.DOCUMENTS_ERROR:
      return { ...state, ...{ error: action.payload, fetching: false } };

    case documentTypes.ORIGINAL_DOCUMENTS_DATA:
      return { ...state, ...{ originalData: action.payload.data, fetching: false } };

    case documentTypes.CATEGORIES_SUCCESS:
      return { ...state, ...{ categories: action.payload } };

    case documentTypes.SET_SEARCH:
      return { ...state, ...{ searchFilters: action.payload } };

    case documentTypes.GET_DOCUMENT_DETAIL:
      return { ...state, ...{ fetchingDocumentDetail: true } };

    case documentTypes.DOCUMENT_DETAIL_SUCCESS:
      return { ...state, ...{ documentDetail: action.payload, fetchingDocumentDetail: false } };

    case documentTypes.PAGE_NUMBER:
      return { ...state, ...{ page: action.payload } };

    case documentTypes.DETAIL_PAGE_MUN:
      return { ...state, ...{ detailPageMun: action.payload } };

    case documentTypes.SET_DOCUMENT_TYPES:
      return { ...state, ...{ documentTypes: action.payload } };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/datahub/reducers.js